import React from 'react';
import {connect} from "react-redux";
import Select from "react-select";
import * as utils from "../../../utils/underwriter";
import UnderwriterForm from "../UnderwriterForm";
import l10n from "../../../l10n/localization";
import {Button} from "react-materialize";
import * as creationActions from "../../../actions/creation";

class SelectUnderwriters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {formData: props.formData};
    }

    onChange(value) {
        this.setState({formData: value}, () => this.props.onChange(value));
    }

    render() {
        return (
            <div className="form-group field">
                <Button type="button" floating onClick={() => this.props.schema.openDrawer(UnderwriterForm, {item: null, selectNewItem: true}, creationActions.destroyingnewlyCreatedUnderwriter())} icon="add" className="add-button btn-md ml5"/>

                <label className="control-label" htmlFor="root_underwriter">
                    {l10n.common.underwriter}<i className='right'>{this.props.schema.title}</i>
                </label>

                <Select
                    backspaceRemoves={false}
                    className="form-control"
                    name="root_underwriter"
                    value={this.props.formData}
                    options={utils.underwriterToSelect(this.props.underwriters)}
                    isLoading={this.props.loading}
                    clearable={false}
                    onChange={this.onChange.bind(this)}
                    simpleValue
                    valueComponent={(props) => {
                        return (
                            <div className="Select-value" title={props.value.title}>
                                <span className="Select-value-label">
                                    {props.children}
                                    <div className="pull-right mr25 input-button-wrapper">
                                        <i>
                                            <Button type="button" floating onClick={() => this.props.schema.openDrawer(UnderwriterForm, {item: props.value.item}, creationActions.destroyingnewlyCreatedUnderwriter())} icon="edit" className="edit-button small"/>
                                        </i>
                                    </div>

                                </span>
                            </div>
                        )
                    }}
                />
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        underwriters: state.underwriter.underwriters,
        loading: state.underwriter.loading
    });
})(SelectUnderwriters);


// WEBPACK FOOTER //
// ./src/components/forms/fields/SelectUnderwriters.js